import { ReactNode, useEffect, useState } from 'react';
import { COLORS, SHADOWS } from '@/game/configs';
interface GameModalProps {
  isOpen: boolean;
  onClose?: () => void;
  children: ReactNode;
}
export function GameModal({ isOpen, onClose, children }: GameModalProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      requestAnimationFrame(() => {
        setIsAnimating(true);
      });
    } else {
      setIsAnimating(false);
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);
  if (!isVisible) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{
        backgroundColor: isAnimating ? 'rgba(0, 0, 0, 0.5)' : 'transparent',
        transition: 'background-color 300ms ease-out',
        backdropFilter: isAnimating ? 'blur(4px)' : 'none',
      }}
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-sm rounded-3xl p-6 sm:p-8"
        style={{
          backgroundColor: COLORS.cream,
          boxShadow: SHADOWS.deep,
          transform: isAnimating ? 'scale(1)' : 'scale(0.9)',
          opacity: isAnimating ? 1 : 0,
          transition: 'transform 300ms cubic-bezier(0.34, 1.56, 0.64, 1), opacity 300ms ease-out',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}